/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Currency,
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
} from './Currency';
import {
    CurrencyCode,
    CurrencyCodeFromJSON,
    CurrencyCodeFromJSONTyped,
    CurrencyCodeToJSON,
} from './CurrencyCode';

/**
 * Equates to *gross sales + tax - discounts - returns - included fees*. This is the amount that will be paid out to program.
 * @export
 * @interface CostBreakdownNetTotal
 */
export interface CostBreakdownNetTotal {
    /**
     * 
     * @type {number}
     * @memberof CostBreakdownNetTotal
     */
    value: number;
    /**
     * 
     * @type {CurrencyCode}
     * @memberof CostBreakdownNetTotal
     */
    currency_code: CurrencyCode;
    /**
     * 
     * @type {number}
     * @memberof CostBreakdownNetTotal
     */
    major_value: number;
    /**
     * 
     * @type {string}
     * @memberof CostBreakdownNetTotal
     */
    display: string;
    /**
     * 
     * @type {string}
     * @memberof CostBreakdownNetTotal
     */
    language: string;
}

export function CostBreakdownNetTotalFromJSON(json: any): CostBreakdownNetTotal {
    return CostBreakdownNetTotalFromJSONTyped(json, false);
}

export function CostBreakdownNetTotalFromJSONTyped(json: any, ignoreDiscriminator: boolean): CostBreakdownNetTotal {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': json['value'],
        'currency_code': CurrencyCodeFromJSON(json['currency_code']),
        'major_value': json['major_value'],
        'display': json['display'],
        'language': json['language'],
    };
}

export function CostBreakdownNetTotalToJSON(value?: CostBreakdownNetTotal | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
        'currency_code': CurrencyCodeToJSON(value.currency_code),
        'major_value': value.major_value,
        'display': value.display,
        'language': value.language,
    };
}

